module.exports = __webpack_public_path__ + "static/media/blog-boy.c2cca4a8.png";